export function randomRange(min, max) {
  return min + Math.random()*(max-min);
}
